import React, { useEffect } from "react";
import { Tabs } from "antd";
import SelectionProcessReport from "./selection_processes/main/SelectionProcessReport";
import ApplicantsReport from "./applicants/main/ApplicantsReport";
import StepsReport from "./steps/main/StepsReport";
import CustomDashboard from "./custom_reports/index";
import { getCurrentUser } from "@frontend/src/utilities/jwtHelper";
const { TabPane } = Tabs;

const main = ({
  current_user,
  enterpriseMultidomain = false,
  selectedOrganization = null,
  applicantIdDashboard,
  selectionProcessIdDashboard,
  stepsDashboardId,
  customReport,
}) => {
  useEffect(() => {
    localStorage.setItem("current_user", JSON.stringify(mapCurrentUser()));
    localStorage.setItem(
      "current_enterprise",
      JSON.stringify(mapCurrentEnterprise())
    );
  });

  function jwtEnterpriseSubdomain() {
    let currentEnterprise = getCurrentUser().enterprise;
    return {
      token: currentEnterprise.token,
      id: currentEnterprise.id,
      name: currentEnterprise.name,
      custom_domain: currentEnterprise.custom_domain,
    };
  }

  function usesSelectedOrganizationSubdomain() {
    return enterpriseMultidomain && Boolean(selectedOrganization?.token);
  }

  function selectedOrganizationSubdomain() {
    if (usesSelectedOrganizationSubdomain()) {
      return {
        token: selectedOrganization.token,
        id: selectedOrganization.id,
        name: selectedOrganization.name,
        custom_domain: selectedOrganization.custom_domain,
      };
    }

    return jwtEnterpriseSubdomain();
  }

  function mapCurrentUser() {
    let currentUser = getCurrentUser();
    return {
      token: currentUser.token,
      subdomain: selectedOrganizationSubdomain(),
      position: currentUser.enterprise_position,
    };
  }

  function mapCurrentEnterprise() {
    let currentEnterprise = getCurrentUser().enterprise;
    let activeSubdomain = selectedOrganizationSubdomain();
    return {
      token: currentEnterprise.token,
      id: currentEnterprise.id,
      name: currentEnterprise.name,
      custom_domain: activeSubdomain.custom_domain,
      subdomain: activeSubdomain,
      modules: [
        {
          id: 73,
          active: true,
          module_code: "rkm_14",
        },
      ],
    };
  }

  function activeOrganizationToken() {
    if (!usesSelectedOrganizationSubdomain()) {
      return null;
    }

    return selectedOrganization.token;
  }

  function hasCustomReport() {
    return (
      customReport &&
      customReport["active"] === "true" &&
      customReport["dashboard_id"]
    );
  }

  return (
    <Tabs defaultActiveKey="1" animated={false}>
      <TabPane tab="Detalle Procesos" key="1">
        <SelectionProcessReport
          idDashboard={selectionProcessIdDashboard}
          enterpriseToken={mapCurrentEnterprise().token}
          organizationDomainToken={activeOrganizationToken()}
        />
      </TabPane>
      <TabPane tab="Detalle Postulaciones" key="2">
        <ApplicantsReport
          idDashboard={applicantIdDashboard}
          enterpriseToken={mapCurrentEnterprise().token}
          organizationDomainToken={activeOrganizationToken()}
        />
      </TabPane>
      <TabPane tab="Métricas por etapas" key="3">
        <StepsReport
          idDashboard={stepsDashboardId}
          enterpriseToken={mapCurrentEnterprise().token}
          organizationDomainToken={activeOrganizationToken()}
        />
      </TabPane>
      {hasCustomReport() && (
        <TabPane tab="Reporte personalizado" key="4">
          <CustomDashboard
            idDashboard={customReport["dashboard_id"]}
            enterpriseToken={mapCurrentEnterprise().token}
            organizationDomainToken={activeOrganizationToken()}
          />
        </TabPane>
      )}
    </Tabs>
  );
};

export default main;
